import { carouselData } from "@/mocks/homeData";

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">焦点专题</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">精选热门影视专题，深度内容一次看过瘾</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {carouselData.map((item) => (
            <article
              key={item.title}
              className="group relative bg-background-100 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = "none";
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-950 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="px-2 py-0.5 bg-background-950/70 text-primary-500 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.rating} 分
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-foreground-100 text-sm md:text-lg font-heading mb-1">{item.title}</h3>
                <p className="text-foreground-500 text-xs mb-2">{item.subtitle}</p>
                <p className="text-foreground-600 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}